module.exports = __webpack_public_path__ + "public/media/marketeer-header-icon.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/marketeer-header-icon.png
// module id = ./images/services/marketeer-header-icon.png
// module chunks = 0